"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _Blog = _interopRequireDefault(require("./Blog"));

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchBlogsActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_Blog.default, action.payload.data.objects, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateBlogActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _Blog.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateBlogActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _Blog.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteBlogActionTypes.SUCCESS, function (state, action) {
  return state.delete(action.payload.props.id);
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateBlogNotificationEmailsActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _Blog.default(action.payload.data));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;